import {ErrorModel} from '../app.model';
import {ACTION_TYPES} from '../app.types';
import {TargetSystemModel} from '../target/target-system.model';
import {DistributionAccountModel} from './distribution-account.model';
import {DistributionAccountAction} from './distribution-account.service';

const STATE_FLAGS = {
  distributionAccountIsCreated: false,
  error: null
};

const INITIAL_STATE = {
  distributionAccount: null,
  distributionAccounts: [],
  targetSystems: [],
  ...STATE_FLAGS
};

export function distributionAccountContainer(state: any = INITIAL_STATE,
                                             action: DistributionAccountAction = {type: '?'}) {

  const newState = {...state, ...STATE_FLAGS};

  switch (action.type) {

    case ACTION_TYPES.TARGET_SYSTEM_LIST_GET:
      return {...newState, targetSystems: action.targetSystems};

    case ACTION_TYPES.DISTRIBUTION_ACCOUNT_LIST_SET:
      newState.distributionAccounts = newState.distributionAccounts || [];
      newState.distributionAccounts.push(action.distributionAccount);
      newState.distributionAccount = action.distributionAccount;
      return {...newState, distributionAccountIsCreated: true};

    case ACTION_TYPES.DISTRIBUTION_ACCOUNT_LIST_UPDATE:
      newState.distributionAccount = action.distributionAccount;

      try {
        const oldItemIndex = newState.distributionAccounts
          .findIndex((it: DistributionAccountModel) => it.id === action.distributionAccount?.id);
        if (oldItemIndex >= 0) {
          newState.distributionAccounts[oldItemIndex] = action.distributionAccount;
        }

        const oldTargetSystemIndex = newState.targetSystems
          .findIndex((it: TargetSystemModel) =>
            it.distributionAccounts !== undefined
            && it.distributionAccounts.findIndex((it2: DistributionAccountModel) => it2.id === action.distributionAccount?.id) >= 0
          );

        if (oldTargetSystemIndex >= 0) {
          const oldDistributionAccountIndex = newState.targetSystems[oldTargetSystemIndex].distributionAccounts
            .findIndex((it: DistributionAccountModel) => it.id === action.distributionAccount?.id);
          newState.targetSystems[oldTargetSystemIndex].distributionAccounts[oldDistributionAccountIndex] = action.distributionAccount;
        }
      } catch (e) {
        console.error(e);
      }
      return {...newState, distributionAccountIsUpdated: true};

    case ACTION_TYPES.DISTRIBUTION_ACCOUNT_LIST_GET:
      return {...newState, distributionAccounts: action.distributionAccounts};

    case ACTION_TYPES.DISTRIBUTION_ACCOUNT_ERROR:
      return {...newState, error: action.error};

    default:
      return state;

  }
}

export const targetSystemListSelector = (state: any): TargetSystemModel[] => state.distributionAccountContainer.targetSystems || [];
export const distributionAccountSelector = (state: any): DistributionAccountModel => state.distributionAccountContainer.distributionAccount;
export const distributionAccountCreated = (state: any): boolean => state.distributionAccountContainer.distributionAccountIsCreated;
export const distributionAccountUpdated = (state: any): boolean => state.distributionAccountContainer.distributionAccountIsUpdated;
export const distributionAccountErrorSelector = (state: any): ErrorModel => state.distributionAccountContainer.error as ErrorModel;
